import script from "./SideNavOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./SideNavOverlay.vue?vue&type=script&setup=true&lang=js"

import "./SideNavOverlay.vue?vue&type=style&index=0&id=4f64d3a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f64d3a9"]])

export default __exports__